import { render, staticRenderFns } from "./InstitutionalShareholdingDetails.vue?vue&type=template&id=7b5269bf&scoped=true"
import script from "./InstitutionalShareholdingDetails.vue?vue&type=script&lang=js"
export * from "./InstitutionalShareholdingDetails.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalShareholdingDetails.vue?vue&type=style&index=0&id=7b5269bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5269bf",
  null
  
)

export default component.exports